import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export function getB2bContactFormStyles(theme: Theme) {
  return StyleSheet.create({
    container: {
      width: '100%' as never,
      maxWidth: 520,
      alignSelf: 'center' as const,
      padding: 20,
      borderRadius: 16,
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    title: {
      fontSize: 18,
      fontWeight: '800',
      color: theme.gray[900],
      marginBottom: 4,
    },
    subtitle: {
      fontSize: 14,
      color: theme.gray[600],
      marginBottom: 16,
    },
    label: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.gray[700],
      marginBottom: 4,
    },
    input: {
      borderWidth: 1,
      borderColor: theme.gray[300],
      borderRadius: 10,
      paddingHorizontal: 14,
      paddingVertical: 12,
      fontSize: 16,
      color: theme.gray[900],
      backgroundColor: theme.background.primary,
      marginBottom: 12,
    },
    textArea: {
      borderWidth: 1,
      borderColor: theme.gray[300],
      borderRadius: 10,
      paddingHorizontal: 14,
      paddingVertical: 12,
      fontSize: 16,
      color: theme.gray[900],
      backgroundColor: theme.background.primary,
      marginBottom: 12,
      minHeight: 80,
      textAlignVertical: 'top' as const,
      ...((Platform.OS === 'web' && { verticalAlign: 'top' }) as any),
    },
    submitBtn: {
      backgroundColor: theme.primary,
      paddingVertical: 14,
      paddingHorizontal: 24,
      borderRadius: 10,
      alignSelf: 'center' as const,
      marginTop: 4,
    },
    submitBtnDisabled: {
      opacity: 0.5,
    },
    submitBtnText: {
      color: theme.white,
      fontWeight: '700',
      fontSize: 16,
      textAlign: 'center' as const,
    },
    errorText: {
      color: theme.error,
      marginTop: 4,
      marginBottom: 8,
      textAlign: 'center' as const,
    },
    successText: {
      color: theme.success,
      fontSize: 15,
      fontWeight: '600',
      textAlign: 'center' as const,
      marginTop: 12,
    },
    pressed: {
      opacity: 0.85,
    },
    memo: {
      fontSize: 12,
      color: theme.gray[400],
      textAlign: 'center' as const,
      marginTop: 16,
    },
  })
}
